export const domainConfig = {
  id: "real-estate",
  name: "Bất động sản",
  icon: "🏠",
  description: "Tạo nội dung cho lĩnh vực bất động sản",

  projectTypes: {
    "Dự án khu đô thị (hỗn hợp)": 1,
    "Dự án chung cư": 2,
    "Dự án nhà liền kề, biệt thự": 3,
    "Dự án nhà phố (shophouse)": 4,
    "Dự án đất nền": 5,
    "Dự án nghỉ dưỡng": 6,
    "Dự án Nhà ở xã hội": 7,
    "Dự án khu công nghiệp": 8,
    "Dự án Trung tâm thương mại": 9,
    "Dự án văn phòng cho thuê": 10,
    "Nhà phố (riêng lẻ)": 11,
    "Lô đất": 12,
    "Căn hộ (riêng lẻ)": 13,
  },

  contentTypes: {
    "Câu chuyện thương hiệu về dự án": 1,
    "Giới thiệu, cập nhật thông tin dự án": 2,
    "Quảng cáo dự án, thúc đẩy bán hàng": 3,
    "Đưa tin sự kiện đặc biệt, chương trình khuyến mại": 4,
    "Quảng cáo bán 1 bất động sản lẻ": 5,
    "Quảng cáo cho thuê 1 bất động sản lẻ": 6,
    "Tuyển dụng môi giới phân phối": 7,
    "Phân tích thị trường": 8,
    "Chia sẻ kiến thức đầu tư": 9,
    "Chia sẻ kiến thức pháp lý": 10,
    "Chia sẻ kinh nghiệm mẹo chọn bất động sản": 11,
    "Chia sẻ kinh nghiệm phong thuỷ": 12,
    "Chia sẻ câu chuyện thành công": 13,
  },

  defaults: {
    projectType: "Dự án khu đô thị (hỗn hợp)",
    contentType: "Câu chuyện thương hiệu về dự án",
    postLength: "Ngắn gọn",
    postStyles: ["Chuyên nghiệp"],
  },

  labels: {
    projectTypeLabel: "Loại hình BĐS",
    contentTypeLabel: "Nội dung chủ đạo",
    projectInfoLabel: "Thông tin dự án/BĐS",
    projectInfoPlaceholder: "Mô tả chi tiết về dự án bất động sản...",
    targetCustomerLabel: "Khách hàng mục tiêu",
    targetCustomerPlaceholder:
      "VD: Gia đình trẻ, nhà đầu tư, người cao tuổi...",
  },

  settings: {
    requiresLocation: true,
    requiresPrice: true,
  },
};
